import React from 'react';
import { MicroTrainingsNewslettersList as NewslettersList } from '../../components';

const Newsletters = () => {
  return (
    <NewslettersList adminPage="newsletters" resource="newsletter" />
  );
};

export default Newsletters;